import Service, { inject as service } from '@ember/service';

export default class ShGeneralInvoiceTransactionCommands extends Service {
  @service api;

  /**
   *
   * @param shGeneralInvoiceId
   * @returns {*}
   */
  deleteShGeneralInvoiceTransactionTask({
    shGeneralInvoiceTransactionId,
  }) {
    return this.api.delete(`sh-general-invoice-transactions/${shGeneralInvoiceTransactionId}`);
  }
}
